/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 */
import { Outlet } from 'react-router-dom';

export const BuildingOutlet = () => <Outlet />;
